import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { PropertyGrid, Button } from '@leverege/ui-elements';
import Editor from '@monaco-editor/react';
import S from './PlainTextDetail.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function PlainTextDetail(props) {
  const {
    rsrc,
    width
  } = props;
  const [contents, setContents] = useState();
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      const url = rsrc.data.data.url;
      const fContents = await fetch(url).then(res => res.text());
      if (!cancelled) {
        setContents(fContents);
      }
    };
    const cancel = () => {
      cancelled = true;
    };
    run();
    return cancel;
  }, [rsrc]);
  return /*#__PURE__*/_jsxs(PropertyGrid, {
    vertical: true,
    className: classnames(S.grid, S.win),
    children: [/*#__PURE__*/_jsx(PropertyGrid.Item, {
      stretch: true,
      label: "text",
      children: /*#__PURE__*/_jsx(Editor, {
        className: S.editor,
        height: "400px",
        width: width ? width - 72 : null,
        defaultLanguage: "plaintext",
        value: contents,
        options: {
          readOnly: true,
          minimap: {
            enabled: false
          }
        },
        theme: "vs-dark"
      })
    }), /*#__PURE__*/_jsx(PropertyGrid.Item, {
      label: "url",
      children: /*#__PURE__*/_jsx(Button, {
        onClick: () => navigator.clipboard.writeText(rsrc.data?.data?.url),
        children: "copy"
      })
    })]
  });
}
PlainTextDetail.PLUGIN = {
  type: 'text/plain',
  component: PlainTextDetail
};
export default PlainTextDetail;